
import { Vue, Component } from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";

@Component
export default class Home extends Vue {
  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "person",
  });

  get caption() {
    return this.dataSource.model?.name;
  }

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Люди",
        to: "/manage/persons/",
        exact: true,
      },
      {
        text: this.dataSource.model?.fullName,
        disabled: true,
      },
    ];
  }
}
